import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { WaitlistEntryEntity } from './waitlist-entry.entity'

export class WaitlistEntriesRepository extends BaseRepository<WaitlistEntryEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'waitlist-entries', token, cache)
    }
}
